import React, { FC, ReactNode } from "react";
import { ListItemIcon, ListItemText, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

import { ListItemButtonStyled } from "./SidebarSectionItem.styled";

import { useSidebarStateStore } from "@store/sidebar";
import { Box, Chip } from "@components/base";

export type SidebarSectionChild = {
  title: string;
  path: string;
  isVisible?: boolean;
  icon?: ReactNode;
};

interface SidebarSectionItem {
  title: string;
  // TODO JS typed
  path: string;
  icon: ReactNode;
  active?: boolean;
  children?: SidebarSectionChild[];
  isVisible?: boolean;
  hasChip?: boolean;
}

const SidebarSectionItem: FC<SidebarSectionItem> = ({
  title,
  path,
  icon,
  active,
  hasChip = false,
}) => {
  const navigate = useNavigate();
  const { sidebarCollapsed, setMobileDrawerOpen } = useSidebarStateStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (): void => {
    if (isMobile) {
      setMobileDrawerOpen(false);
    }
    navigate(path);
  };

  return (
    <ListItemButtonStyled
      selected={active}
      onClick={handleClick}
    >
      {icon && (
        <ListItemIcon
          sx={
            sidebarCollapsed
              ? {
                  transition: "all 0.5s",
                  transitionDelay: "0.3s",
                  width: "100% !important",
                  display: "flex",
                  justifyContent: "center",
                }
              : {
                  width: 20,
                }
          }
        >
          {sidebarCollapsed && hasChip ? (
            <Box position="relative">
              {icon}
              <Chip
                label="BETA"
                color="warning"
                size="small"
                sx={{
                  maxWidth: "40px",
                  position: "absolute",
                  top: -20,
                  right: -10,
                  fontWeight: 400,
                  borderRadius: 2,
                  fontSize: 10,
                  height: 14,
                  zIndex: 1,
                  gap: 1,
                }}
              />
            </Box>
          ) : (
            <>{icon}</>
          )}
        </ListItemIcon>
      )}
      {hasChip ? (
        <Box position="relative">
          <ListItemText
            primary={title}
            sx={{ transition: "opacity 0.5s", opacity: sidebarCollapsed ? 0 : 1 }}
          />
          <Chip
            label="BETA"
            color="warning"
            size="small"
            icon={<FeatherIcon icon="zap" size={10} />}
            sx={{
              position: "absolute",
              top: -20,
              right: -50,
              fontWeight: 400,
              borderRadius: 2,
              fontSize: 10,
              height: 14,
              zIndex: 1,
              gap: 1,
            }}
          />
        </Box>
      ) : (
        <ListItemText
          primary={title}
          sx={{ transition: "opacity 0.5s", opacity: sidebarCollapsed ? 0 : 1 }}
        />
      )}
    </ListItemButtonStyled>
  );
};

export default SidebarSectionItem;
